
import { Modal, Button, Form } from "react-bootstrap";
import React, { useState, useEffect } from 'react';
import DataGrid from "react-data-grid";
import "./styles.scss";

const formatSelectedTickers = (tickers) => {
    const formattedTickers = [];
    for (const ticker of tickers) {
        formattedTickers.push({ tickerWithExchange: ticker })
    }
    return formattedTickers;
}

const ViewTickersModal = ({ show, onClose, tickers, userNotes, handleCopy }) => {
    const [sortColumns, setSortColumns] = useState([]);
    const [selectedTickers, setSelectedTickers] = useState(formatSelectedTickers(tickers));

    const handleClose = () => {
        setSortColumns([]);
        setSelectedTickers([]);
        onClose();
    }

    const columns = [
        {
            key: "tickerWithExchange",
            name: 'Ticker',
            sortable: true,
            filterable: true,
            frozen: true
        }
    ]

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            setSortColumns([]);
            setSelectedTickers(formatSelectedTickers(tickers))
        }
        return () => { isMounted = false }
    }, [tickers, show])

    return (
        <Modal show={show} onHide={handleClose} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title>Selected Tickers</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="selected-tickers-grid">
                    <DataGrid
                        className={'grid rdg-light filter-container'}
                        columns={columns}
                        rows={selectedTickers}
                        sortColumn={sortColumns}
                        onSortColumnsChange={setSortColumns}
                    />
                </div>
                <div className="userNotes">
                    <Form.Group>
                        <Form.Label>User Notes</Form.Label>
                        <Form.Control
                            as="textarea"
                            value={userNotes}
                            disabled
                        >
                        </Form.Control>
                    </Form.Group>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="btn btn-primary" onClick={handleCopy} style={{ "width": "30%" }}>
                    Copy Tickers
                </Button>
                <Button variant="btn btn-secondary" onClick={handleClose} style={{ "width": "20%" }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ViewTickersModal;